module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/create_demand.c37dc608.svg";